// ✅ หากโปรเจกต์ของคุณใช้ ESM แนะนำ import แบบนี้เพื่อให้มี bootstrap.Tooltip ให้เรียกได้แน่นอน
import * as bootstrap from "bootstrap";
// import "bootstrap-icons/font/bootstrap-icons.css";
import "../scss/style.scss";

// GSAP 3
import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  // Expose ให้โค้ดเดิมที่เช็ค window.bootstrap ใช้ได้
  if (!window.bootstrap) window.bootstrap = bootstrap;

  // Tooltips
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  if (tooltips.length > 0 && window.bootstrap && window.bootstrap.Tooltip) {
    [...tooltips].forEach((el) => new window.bootstrap.Tooltip(el));
  }

  // Navbar toggler
  const toggler = document.querySelector("#mobile-menu-toggle");
  const mobileMenu = document.querySelector("#mobile-menu");
  if (toggler && mobileMenu) {
    const icon = toggler.querySelector(".toggle-icon");
    toggler.addEventListener("click", () => {
      if (icon) { icon.classList.toggle("bi-list"); icon.classList.toggle("bi-x"); }
      mobileMenu.classList.toggle("d-none");
      toggler.setAttribute(
        "aria-expanded",
        toggler.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
    });
  }

  // Postlist 4 Blog (CTA แทรกหลังโพสต์ลำดับที่ 4)
  const postList = document.querySelector(".postlist");
  if (postList) {
    const posts = postList.querySelectorAll(".post");
    if (posts.length >= 4) {
      const assetBase = (window.THEME && window.THEME.assetBase) || "";
      const section = document.createElement("section");
      section.className = "cta-section my-4";
      section.innerHTML = `
        <div>
          <div class="cta-box d-flex flex-column flex-sm-row align-items-center justify-content-start gap-4">
            <div class="cta-icon">
              <img src="${assetBase}/assets/images/pages/blog/checklist-icon.svg"
                   alt="Checklist Icon" class="img-fluid" />
            </div>
            <div class="cta-text">
              <h2 class="cta-title mb-2">WHAT MAKES Dentalis, Vejthani International Hospital MEDICINE UNIQUE?</h2>
              <a href="#" class="cta-link">Download Our Checklist</a>
            </div>
          </div>
        </div>`;
      posts[3].insertAdjacentElement("afterend", section);
    }
  }

  // === Load More (AJAX) ===
  // ใช้กับหน้า category-health-article.php
  const loadMoreBtn = document.getElementById("hb-loadmore");
  if (loadMoreBtn && window.THEME && THEME.ajaxUrl && THEME.nonce) {
    loadMoreBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (loadMoreBtn.disabled) return;

      let btnPayload = loadMoreBtn.dataset.payload;
      try {
        btnPayload = typeof btnPayload === "string" ? JSON.parse(btnPayload) : btnPayload;
      } catch (err) {
        console.error("Invalid payload on button:", err);
        return;
      }
      if (!btnPayload || !btnPayload.action) return;

      const originalText = loadMoreBtn.textContent;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = "Loading...";

      try {
        const form = new FormData();
        form.append("action", btnPayload.action);
        form.append("nonce", THEME.nonce);
        form.append("page", btnPayload.next_page);
        form.append("query", JSON.stringify(btnPayload.query || {}));

        const res = await fetch(THEME.ajaxUrl, {
          method: "POST",
          credentials: "same-origin",
          body: form,
        });

        const resp = await res.json();
        const d = resp && resp.data ? resp.data : resp;
        const html = d && d.html ? d.html : "";

        if (resp && resp.success && html) {
          const listEl = document.getElementById("hb-postlist");
          const btnWrapEl = (listEl && listEl.querySelector(".text-center.mt-4.d-flex.justify-content-center")) || loadMoreBtn.parentElement || listEl;

          if (btnWrapEl) {
            btnWrapEl.insertAdjacentHTML("beforebegin", html);
          } else if (listEl) {
            listEl.insertAdjacentHTML("beforeend", html);
          }

          btnPayload.next_page = Number(btnPayload.next_page || 1) + 1;

          if (btnPayload.next_page > Number(btnPayload.max_pages || 1)) {
            loadMoreBtn.remove();
          } else {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = originalText;
            loadMoreBtn.dataset.payload = JSON.stringify(btnPayload);
          }
        } else {
          console.warn("Load more returned no usable html:", resp);
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = originalText;
        }
      } catch (err) {
        console.error("Load more failed:", err);
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = originalText;
      }
    });
  }

  // ===== Socials (Vanilla + GSAP 3 แทน jQuery/TweenMax) =====
  const socialBox = document.querySelector('#socials__container .social-box');
  const galleryLinks = document.querySelectorAll('#socials__gallery a');
  const toggleIcon = document.querySelector('#socials__container .social-box .toggle-icon');

  if (socialBox && galleryLinks.length > 0) {
    let animating = false;

    socialBox.addEventListener('click', () => {
      if (animating) return;

      const isOpen = socialBox.classList.contains('open');
      animating = true;

      if (!isOpen) {
        socialBox.classList.add('open');
        if (toggleIcon) toggleIcon.classList.add('close');

        // ทำให้มองเห็นก่อน
        gsap.set(galleryLinks, { visibility: 'visible' });

        // เหมือนเดิมที่เคยใช้ TweenMax.staggerTo
        const tl = gsap.timeline({
          defaults: { ease: 'power3.out' },
          onComplete: () => { animating = false; }
        });
        tl.to(galleryLinks, { opacity: 1, duration: 0.3, stagger: 0.075 })
          .to(galleryLinks, { y: -12, duration: 0.3, stagger: 0.075 }, '<')
          .to(galleryLinks, { y: 0, duration: 0.2, stagger: 0.075 }, '>-0.2');
      } else {
        const tl = gsap.timeline({
          onComplete: () => {
            socialBox.classList.remove('open');
            if (toggleIcon) toggleIcon.classList.remove('close');
            galleryLinks.forEach((el) => {
              el.style.visibility = 'hidden';
              el.style.opacity = '0';
              el.style.transform = ''; // reset translate
            });
            animating = false;
          }
        });
        tl.to(galleryLinks, { opacity: 0, duration: 0.3, stagger: 0.075 });
      }
    });
  }

  // ===== Go to top =====
  const goTopBtn = document.querySelector('.flyer-wrapper #go__top');
  if (goTopBtn) {
    let scrollTimer;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (window.scrollY > 250) {
          goTopBtn.classList.add('visible');
        } else {
          goTopBtn.classList.remove('visible');
        }
      }, 150);
    });

    goTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

});
